module.exports = __webpack_public_path__ + "img/japan-external-causes-male.68708792.png";